import React from "react";
import {SpeechDispatchContext} from '../providers';

function useDispatchSpeech() {
    return React.useContext(SpeechDispatchContext);
}

export {useDispatchSpeech}
